export default __webpack_public_path__ + "static/media/outstanding.e5a3079c.svg";